import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import './style.css'
import {FontAwesomeIcon} from './plugins/fontawesome.ts'
import Toast   from './plugins/toast.ts'
import { toastOptions } from './plugins/toast.ts'
import 'vue-toastification/dist/index.css'




// Import base components
import AppButton from './components/base/AppButton.vue'
import AppForm from './components/base/AppForm.vue'
import AppInput from './components/base/AppInput.vue'
import ErrorBoundary from './components/base/ErrorBoundary.vue'
import LoadingSpinner from './components/base/LoadingSpinner.vue'
import OfflineIndicator from './components/base/OfflineIndicator.vue'

// Create Vue application
const app = createApp(App)

// Configure Pinia with persistence
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Register base components globally
app.component('AppButton', AppButton)
app.component('AppForm', AppForm)
app.component('AppInput', AppInput)
app.component('ErrorBoundary', ErrorBoundary)
app.component('LoadingSpinner', LoadingSpinner)
app.component('OfflineIndicator', OfflineIndicator)
app.component('font-awesome-icon', FontAwesomeIcon)

// Use plugins
app.use(pinia)
app.use(router)
app.use(Toast, toastOptions)




// Mount the app
app.mount('#app')
